<template>
  <BasicLayout>
    <template #wrapper>
      <el-card class="box-card">
        <div ref="chartContainer" style="width: 100%; height: 400px;" />
      </el-card>
    </template>
  </BasicLayout>

</template>

<script>
import echarts from 'echarts'

export default {
  name: 'UserSourceStat',
  props: {
  },
  data() {
    return {
      chart: {},
      option: {}
    }
  },
  mounted() {
    this.$nextTick(() => {
      this.initChart()
    })
  },
  methods: {
    initChart() {
      this.chart = echarts.init(this.$refs.chartContainer)
      this.option = {
        color: ['#1E90FF', '#7B68EE', '#FF69B4', '#FF7F50', '#BA55D3'],
        title: {
          text: ''
        },
        xAxis: {
          name: '来源',
          type: 'category',
          data: [],
          axisLabel: {
            rotate: 45 // 标签旋转45度
          }
        },
        legend: {
          data: ['未付费', '0.99-4.99', '5-9.99', '10-49.99', '>49.99'],
          x: 'center',
          y: 'bottom'
        },
        grid: {
          left: '3%',
          right: '4%',
          bottom: '10%',
          containLabel: true
        },
        yAxis: [{
          type: 'value',
          axisLabel: {
            formatter: '{value}' // 使用默认的数值格式
          }
        }],
        toolbox: {
          show: true,
          feature: {
          }
        },
        tooltip: {
          trigger: 'axis'
        },
        series: [
          {
            name: '未付费',
            data: [],
            type: 'line',
            smooth: true,
            label: {
              // show: true,
              position: 'top', // 标签显示在折线图顶部
              formatter: '{c}' // 显示数值
            }
          },
          {
            name: '0.99-4.99',
            data: [],
            type: 'line',
            smooth: true,
            label: {
              // show: true,
              position: 'top', // 标签显示在折线图顶部
              formatter: '{c}' // 显示数值
            }
          },
          {
            name: '5-9.99',
            data: [],
            type: 'line',
            smooth: true,
            label: {
              // show: true,
              position: 'top', // 标签显示在折线图顶部
              formatter: '{c}' // 显示数值
            }
          },
          {
            name: '10-49.99',
            data: [],
            type: 'line',
            smooth: true,
            label: {
              // show: true,
              position: 'top', // 标签显示在折线图顶部
              formatter: '{c}' // 显示数值
            }
          },
          {
            name: '>49.99',
            data: [],
            type: 'line',
            smooth: true,
            label: {
              // show: true,
              position: 'top', // 标签显示在折线图顶部
              formatter: '{c}' // 显示数值
            }
          }
        ]
      }
    },
    refresh(data) {
      const p0 = []
      const p1 = []
      const p2 = []
      const p3 = []
      const p4 = []
      const level = []
      for (const i in data) {
        level.push('等级' + data[i].level)
        p0.push(data[i].p0)
        p1.push(data[i].p1)
        p2.push(data[i].p2)
        p3.push(data[i].p3)
        p4.push(data[i].p4)
      }
      this.option.xAxis.data = level
      this.option.series[0].data = p0
      this.option.series[1].data = p1
      this.option.series[2].data = p2
      this.option.series[3].data = p3
      this.option.series[4].data = p4
      this.chart.setOption(this.option, true)
    }
  }

}
</script>

<style scoped>

</style>
